import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// context
import { useDropDown } from "../useDropDown";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

const sharedStyles = css`
    background-color: ${({ $isDarkMode }) =>
        $isDarkMode ? colors.secondary.orca : colors.primary.snow};
    width: ${convertPxToRem(19)};
    height: ${convertPxToRem(19)};
    position: absolute;
    top: ${({ $top }) => convertPxToRem($top - 2)};
    left: 50%;
    transform: rotate(45deg) translateX(-60%);
`;

const BottomTrianglesStyled = styled.div`
    ${sharedStyles}
    box-shadow: 0rem 0rem ${convertPxToRem(8)}
        ${({ $isDarkMode }) =>
            $isDarkMode ? `rgba(255, 255, 255, 0.35)` : `rgba(0, 0, 0, 0.35)`};
    z-index: ${({ $zIndex }) => $zIndex};
`;
const TopTrianglesStyled = styled.div`
    ${sharedStyles}
    /* always 2 above the bottom triangle - sandwhiching Panel {children}*/
    z-index: ${({ $zIndex }) => $zIndex + 2};
`;

// component
const Triangles = ({ children }) => {
    const { hasTriangle, isOpen, top, zIndex, isDarkMode } = useDropDown();

    if (!hasTriangle) return children;

    return (
        <>
            <BottomTrianglesStyled
                hidden={!isOpen}
                $top={top}
                $zIndex={zIndex}
                $isDarkMode={isDarkMode}
            />
            {children}
            <TopTrianglesStyled
                hidden={!isOpen}
                $top={top}
                $zIndex={zIndex}
                $isDarkMode={isDarkMode}
            />
        </>
    );
};

export default Triangles;

// prop-types
Triangles.propTypes = {
    children: PropTypes.any
};
